import { ActionReducer } from '@ngrx/store';

import { State } from './index'

export function logger(reducer: ActionReducer<State>): ActionReducer<State> {
  return (state: State, action: any): State => {
    if(action.type !== '[Application] Application Activity') {
      console.log('state', state);
      console.log('action', action);
    }

    return reducer(state, action);
  };
}



// WEBPACK FOOTER //
// ./src/app/core/store/reducers/logger.meta-reducer.ts